import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryExternalIdUpdateEvent } from "../../../common/types/order-details-history-entry-event";

const getCargoExternalOrderIdLabel = (
  cargoExternalOrderId: OrderDetailsHistoryEntryExternalIdUpdateEvent["newCargoExternalOrderId"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .externalIdUpdateEntry.newCargoExternalOrderIdTemplateText;

  return translations.replace(
    "#{cargoExternalOrderId}",
    cargoExternalOrderId ?? "-----",
  );
};

const getCargoExternalOrderIdTitle = (
  cargoExternalOrderId: OrderDetailsHistoryEntryExternalIdUpdateEvent["newCargoExternalOrderId"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .externalIdUpdateEntry.newCargoExternalOrderIdTemplateText;

  return translations.replace(
    "#{cargoExternalOrderId}",
    cargoExternalOrderId ?? "-----",
  );
};

const orderDetailsHistoryEntryExternalIdUpdateContentHelper = {
  getCargoExternalOrderIdLabel,
  getCargoExternalOrderIdTitle,
};

export default orderDetailsHistoryEntryExternalIdUpdateContentHelper;
